function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { A } from '@ember/array';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
import { ItemTypeConnect } from '@square/dashboard-items-data/utils/item-type-constants';
export default class Item extends CatalogObjectSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "attrs", {
      variations: {
        embedded: 'always',
        serializedOnFragment: 'item_data'
      },
      event: {
        embedded: 'always',
        serializedOnFragment: 'item_data'
      },
      images: {
        serialize: 'ids',
        deserialize: 'ids',
        serializedOnFragment: 'item_data',
        serializedOnKey: 'image_ids'
      },
      taxes: {
        serialize: 'ids',
        deserialize: 'ids',
        serializedOnFragment: 'item_data',
        serializedOnKey: 'tax_ids'
      }
    });
  }
  normalize(type, item) {
    // TODO: [can] Ember data is not updating categories when the backend responds back without
    // the categories key. I'm not sure this occurs with other keys. If it does, we should implement
    // a smarter logic like here https://github.com/squareup/dashboard/blob/587ff6ae5e1e50aea8af870c504357dbe3366f6e/frontend/%40square/dashboard-items-data/addon/serializers/items-v3-base.js#L57
    if (item.item_data) {
      item.item_data.categories = item.item_data.categories ?? [];
      item.item_data.reporting_category = item.item_data.reporting_category ?? null;
      item.item_data.channels = item.item_data.channels ?? [];
      if (item.item_data.channel_integrations) {
        item.item_data.channel_integrations = item.item_data.channel_integrations.map(integration => {
          return {
            ...integration,
            channel_id: integration.id
          };
        });
      }
      if (item.item_data.location_overrides) {
        item.item_data.location_overrides = item.item_data.location_overrides.map(override => {
          return {
            ...override,
            channel_integrations: override.channel_integrations?.map(integration => {
              return {
                ...integration,
                channel_id: integration.id
              };
            }) || []
          };
        });
      } else {
        item.item_data.location_overrides = [];
      }
      this.normalizeFoodAndBev(type, item);
    }
    return super.normalize(type, item);
  }

  // Ember data fragments don't clear the existing stale data corresponding to key that the back-end omits.
  // This function ensures that the state of item_data.food_and_beverage_details is always predictable and matches.
  // server state
  normalizeFoodAndBev(type, item) {
    if (item.item_data.product_type !== ItemTypeConnect.FOOD_AND_BEV) {
      item.item_data.food_and_beverage_details = null;
      return;
    }
    if (!item.item_data.food_and_beverage_details) {
      item.item_data.food_and_beverage_details = {
        calorie_count: null,
        dietary_preferences: [],
        ingredients: []
      };
      return;
    }
    item.item_data.food_and_beverage_details.calorie_count ??= null;
    item.item_data.food_and_beverage_details.dietary_preferences ??= [];
    item.item_data.food_and_beverage_details.ingredients ??= [];
  }
  serialize(snapshot, options) {
    const item = super.serialize(snapshot, options);
    // Make sure reporting category is first in the list
    // This is to handle an ember data fragment array issue
    // Server will return categories in a different order if reporting category changes
    // So we should just always make sure reporting category is first in our local model to prevent issues
    if (item.item_data?.reporting_category && item.item_data?.categories?.length > 1) {
      const categoriesWithoutReporting = item.item_data.categories.filter(cat => cat.id !== item.item_data.reporting_category.id);
      item.item_data.categories = A([item.item_data.reporting_category, ...categoriesWithoutReporting]);
    }

    // Transform channelId -> id for channel integrations
    if (item.item_data?.channel_integrations) {
      item.item_data.channel_integrations = item.item_data.channel_integrations.map(integration => {
        return {
          state: integration.state,
          id: integration.channel_id
        };
      });
    }

    // Transform channelId -> id for location overrides channel integrations
    if (item.item_data?.location_overrides) {
      item.item_data.location_overrides = item.item_data.location_overrides.map(override => {
        return {
          ...override,
          channel_integrations: override.channel_integrations?.map(integration => {
            return {
              state: integration.state,
              id: integration.channel_id
            };
          }) || []
        };
      });
    }
    return item;
  }
}